module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c2073917e0491bdcb2d046d298bcd083.png";